<template>
  <AppBar v-if="!isMobile" />
  <div class="login-box" :style="isMobile ? '' : 'width: 400px; height: fit-content; margin: auto; border-radius: 5px; border: 1px solid lightgrey; padding-bottom: 20px; box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);'">
    <v-form class="form-login" v-model="valid" ref="form">
      <v-img src="@/assets/logo.png" style="margin: auto; cursor: pointer;" width="70%" @click="$router.push('/')" />

      <v-text-field
        v-mask="'###.###.###-##'"
        density="compact"
        label="CPF"
        prepend-inner-icon="mdi-account"
        v-model="dados.input"
        :rules="[(v) => !!v || 'CPF é obrigatório para efetuar login']"
        required
        variant="outlined"
      />

      <v-text-field
        ref="txtSenha"
        density="compact"
        label="Senha"
        v-model="dados.senha"
        :rules="[(v) => !!v || 'Senha é obrigatória']"
        prepend-inner-icon="mdi-lock"
        required
        type="password"
        variant="outlined"
        @keyup.enter="login"
      />

      <v-btn
        block
        :loading="loading"
        color="primary"
        text="Entrar"
        @click="login"
      />

      <!--p class="text-center login-link"><a href="#">Recuperar Senha</a></p-->
    </v-form>

    <v-snackbar v-model="snackbar.active" :color="snackbar.color" location="top" timeout="6000">
      <template #default> {{ snackbar.text }} </template>
    </v-snackbar>
  </div>
</template>

<script lang="ts">
  import { AxiosResponse } from 'axios'
  import { mask } from 'vue-the-mask'

  export default {
    name: 'LoginPage',
    directives: { mask },
    data: () => ({
      dados: {
        input: '',
        senha: ''
      },
      loading: false,
      snackbar: {
        active: false,
        color: '',
        text: ''
      },
      valid: false,
    }),
    methods: {
      async login() {
        await this.$refs.form.validate();

        if (this.valid) {
          this.$refs.txtSenha.blur();
          const data = this.dados.input.includes('@') ? {
            email: this.dados.input,
            senha: this.dados.senha
          } : {
            cpf: this.dados.input.replace(/[^0-9]/g, ''),
            senha: this.dados.senha
          }
          try {
            this.loading = true
            const response: AxiosResponse = await this.axios.post('admins/login', data);
            if (response.status === 200) {
              localStorage.setItem('token', response.data.token);
              this.$router.push('/dashboard');
            }
          } catch (e: Error | any) {
            let contextError = '';
            if (e.response.data.error === 'Admin not found') {
              contextError = 'Email, CPF ou senha incorretos.';
            }
            this.loading = false;
            this.snackbar.active = true;
            this.snackbar.color = 'error';
            this.snackbar.text = 'Erro ao realizar login! ' + contextError;
          }
        }
      }
    },
    computed: {
      isMobile() {
        return this.$vuetify.display.mobile;
      }
    }
  }
</script>

<style scoped>
.login-box {
    width: 100%;
    height: 100%;
    display: grid;
    place-items: center;
}

.form-login {
    padding: 15px;
    width: 100%;
}

.login-link {
    margin-top: 15px;
    font-size: 12px;
}
.login-link a {
    text-decoration: none;
    color: rgb(150, 150, 200);
}
</style>
